var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoto2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.039,
    height: 65.066,
    viewBox: "0 0 90.039 65.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#efe7e4;}.b{fill:#d8d1d0;}.c{fill:#f6dc74;}.d{fill:#1b8379;}.e{fill:#105d56;}.f{fill:#fff;}.g{fill:#939393;}.h{fill:#ffc89f;}.i{fill:#f7b081;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -71.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.266 72.319)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 47.455,
    height: 12.976
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 47.455,
    height: 12.976,
    transform: "translate(0 24.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 47.455,
    height: 12.976,
    transform: "translate(0 49.456)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.266 81.783)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 47.455,
    height: 3.513,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 47.455,
    height: 3.513,
    transform: "translate(0 24.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 47.455,
    height: 3.513,
    transform: "translate(0 49.456)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M104.308,244.937l-2.43,4.764h2.635l2.215-4.3A17.451,17.451,0,0,0,104.308,244.937Z",
    transform: "translate(-83.962 -143.347)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.266 72.319)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 22.094,
    height: 12.976
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 38.916,
    height: 12.976,
    transform: "translate(0 24.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 30.819,
    height: 12.976,
    transform: "translate(0 49.456)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.266 81.783)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.094,
    height: 3.513,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 38.916,
    height: 3.513,
    transform: "translate(0 24.728)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 30.819,
    height: 3.513,
    transform: "translate(0 49.456)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 76.581)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M24.744,266.48H42v-5.539c0-9.1-8.149-16.557-17.253-16.682-9.1.125-17.253,7.577-17.253,16.682v5.539Z",
    transform: "translate(-6.174 -219.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M97.366,244.259a17.092,17.092,0,0,0-1.756.116c8.37.983,15.5,8.052,15.5,16.566v5.539h3.513v-5.539C114.619,251.836,106.47,244.383,97.366,244.259Z",
    transform: "translate(-78.796 -219.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M66.957,133.806h0a8.269,8.269,0,0,1-8.245-8.245v-7.1a8.269,8.269,0,0,1,8.245-8.245h0a8.269,8.269,0,0,1,8.245,8.245v7.1A8.269,8.269,0,0,1,66.957,133.806Z",
    transform: "translate(-48.387 -108.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M97.366,110.221h0a8.2,8.2,0,0,0-1.756.191,8.276,8.276,0,0,1,6.489,8.054v7.1a8.276,8.276,0,0,1-6.489,8.054,8.2,8.2,0,0,0,1.756.192h0a8.27,8.27,0,0,0,8.245-8.245v-7.1A8.269,8.269,0,0,0,97.366,110.221Z",
    transform: "translate(-78.796 -108.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M85.555,285.912,89.832,282l-2.3-9.968H83.574L81.278,282Z",
    transform: "translate(-66.985 -242.256)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.375 24.889)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M101.4,272.029H98.77l2.3,9.968-2.96,2.709,1.317,1.206L103.7,282Z",
    transform: "translate(-95.229 -267.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M83.958,249.143h3.961l2.215-4.3a15.449,15.449,0,0,0-8.39,0Z",
    transform: "translate(-81.743 -244.259)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.072,127.2a9.556,9.556,0,0,0,4.061-7.814v-7.1a9.562,9.562,0,1,0-19.125,0v7.1a9.556,9.556,0,0,0,4.061,7.814C5.59,129.6,0,136.5,0,144.3v5.539a1.317,1.317,0,0,0,1.317,1.317H8.129a1.317,1.317,0,1,0,0-2.635H2.635V144.3a14.806,14.806,0,0,1,4.8-10.753,16.962,16.962,0,0,1,6.272-3.764l1.489,2.893-2.188,9.5a1.318,1.318,0,0,0,.394,1.267l4.277,3.914a1.317,1.317,0,0,0,1.779,0l4.277-3.914a1.317,1.317,0,0,0,.394-1.267l-2.188-9.5,1.489-2.893a16.961,16.961,0,0,1,6.272,3.764,14.806,14.806,0,0,1,4.8,10.753v4.222H12.52a1.317,1.317,0,0,0,0,2.635h23.3a1.317,1.317,0,0,0,1.317-1.317V144.3C37.14,136.5,31.55,129.6,24.072,127.2Zm-12.43-7.814v-3.6c6.212-.542,8.515-4.809,8.515-4.809s1.5,3.949,5.341,4.731v3.683a6.935,6.935,0,0,1-6.647,6.921c-.088,0-.175-.006-.263-.007h-.036c-.088,0-.176,0-.263.007A6.935,6.935,0,0,1,11.642,119.387ZM18.57,144.6l-2.821-2.582,1.889-8.2H19.5l1.889,8.2Zm1.177-13.414H17.393l-1.057-2.052q.344-.055.689-.1l.08-.008c.2-.022.405-.04.608-.054l.163-.011c.159-.009.318-.014.477-.019.072,0,.144.005.216.005s.144,0,.216-.005c.159,0,.318.009.477.019l.163.011c.2.014.406.032.608.054l.08.008q.346.04.69.1Z",
    transform: "translate(0 -102.729)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.939,71h-9.716a1.317,1.317,0,1,0,0,2.635h8.4V83.978H251.9V73.637h9.938a1.317,1.317,0,1,0,0-2.635H228.484a1.317,1.317,0,0,0-1.317,1.317V85.3a1.317,1.317,0,0,0,1.317,1.317h47.455a1.317,1.317,0,0,0,1.317-1.317V72.319A1.317,1.317,0,0,0,275.939,71ZM229.8,83.978V73.637h19.459V83.978Z",
    transform: "translate(-187.218 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.939,211.615H246.9a1.317,1.317,0,0,0,0,2.635h19.179v10.342H229.8V214.25h12.712a1.317,1.317,0,1,0,0-2.635H228.484a1.317,1.317,0,0,0-1.317,1.317v12.976a1.317,1.317,0,0,0,1.317,1.317h47.455a1.317,1.317,0,0,0,1.317-1.317V212.932A1.317,1.317,0,0,0,275.939,211.615Zm-1.317,12.976h-5.9V214.249h5.9Z",
    transform: "translate(-187.218 -115.885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.939,352.227h-7.31a1.317,1.317,0,0,0,0,2.635h5.993V365.2h-14V354.862h3.617a1.317,1.317,0,1,0,0-2.635H228.484a1.317,1.317,0,0,0-1.317,1.317v12.976a1.317,1.317,0,0,0,1.317,1.317h47.455a1.317,1.317,0,0,0,1.317-1.317V353.544A1.317,1.317,0,0,0,275.939,352.227ZM229.8,365.2V354.861h28.186V365.2Z",
    transform: "translate(-187.218 -231.77)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto2);
export default __webpack_public_path__ + "static/media/photo_2.6c8707a64f1f3b83bf3267248e1dda1a.svg";
export { ForwardRef as ReactComponent };